<div class="list-wrapper">
	<div class="index-list">
		<div class="index-content">
			@for (dotIdx of dotsArray; track dotsArrayTrackBy($index, dotIdx)) {
				<div
					class="index"
					[class]="dotIdx | dotClass: leftActiveIndex : rightActiveIndex"
					[class.active]="dotIdx === index"
					(click)="onDotClick(dotIdx)"
				></div>
			}
		</div>
	</div>
</div>
